import React from "react";
import { useNavigate } from "react-router-dom";
import logoSvg from "../assets/botibonga_logo.svg";

export default function Logo({
  size = "default",
  showText = true,
  clickable = true,
}) {
  const navigate = useNavigate();

  const sizes = {
    small: { icon: 32, text: "text-lg" },
    default: { icon: 40, text: "text-xl" },
    large: { icon: 56, text: "text-3xl" },
  };

  const { icon, text } = sizes[size];

  const handleClick = () => {
    if (clickable) {
      navigate("/dashboard");
    }
  };

  return (
    <div
      className={`flex items-center gap-3 ${clickable ? "cursor-pointer" : ""}`}
      onClick={handleClick}
    >
      <img
        src={logoSvg}
        alt="Botibonga Logo"
        style={{ width: icon, height: icon }}
        className="object-contain"
      />
      {showText && (
        <span className={`font-logo font-extrabold ${text} gradient-text`}>
          Botibonga
        </span>
      )}
    </div>
  );
}
